import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyCugy9S7Ql-7We0GpSzCp_eMqX5hnaNLFA",
  authDomain: "links-d85c4.firebaseapp.com",
  databaseURL: "https://links-d85c4-default-rtdb.firebaseio.com",
  projectId: "links-d85c4",
  storageBucket: "links-d85c4.firebasestorage.app",
  messagingSenderId: "846765033238",
  appId: "1:846765033238:web:e0a3a39e8893c4e9a67237",
  measurementId: "G-FQC463Y7JD",
};

export const app = initializeApp(firebaseConfig);

export default firebaseConfig;
